export const NEGATION = new Set([
  "bare",
  "can't",
  "cant",
  "couldn't",
  "couldnt",
  "doesn't",
  "doesnt",
  "don't",
  "dont",
  "hardly",
  "isn't",
  "isnt",
  "neither",
  "never",
  "no",
  "nobody",
  "none",
  "not",
  "nothing",
  "nowhere",
  "shouldn't",
  "shouldnt",
  "wasn't",
  "wasnt",
  "won't",
  "wont",
  "wouldn't",
  "wouldnt",
  "zero",
]);
